// === Constants ===

export const RENDER_DEBOUNCE = 100;
export const TOOL_GROUP_THRESHOLD = 2;

export const CLAUDE_MODEL_ENTRIES = [
  { alias: 'default', value: 'default', label: '默认（推荐）', desc: '使用默认模型（当前为 Sonnet 4.6）', pricing: '输入/输出 $3 / $15 / 百万 Token' },
  { alias: 'sonnet[1m]', value: 'sonnet[1m]', label: 'Sonnet（1M 上下文）', desc: 'Sonnet 4.6，适合长上下文会话', pricing: '输入/输出 $3 / $15 / 百万 Token' },
  { alias: 'opus', value: 'opus', label: 'Opus', desc: 'Opus 4.6，复杂任务能力最强', pricing: '输入/输出 $5 / $25 / 百万 Token' },
  { alias: 'opus[1m]', value: 'opus[1m]', label: 'Opus（1M 上下文）', desc: 'Opus 4.6，支持 1M 上下文，适合复杂任务', pricing: '输入/输出 $5 / $25 / 百万 Token' },
  { alias: 'haiku', value: 'haiku', label: 'Haiku', desc: 'Haiku 4.5，响应最快，适合快速问答', pricing: '输入/输出 $1 / $5 / 百万 Token' },
];

export const SLASH_COMMANDS = [
  { cmd: '/clear', desc: '清除当前会话' },
  { cmd: '/model', desc: '查看/切换模型' },
  { cmd: '/mode', desc: '查看/切换权限模式' },
  { cmd: '/cost', desc: '查看会话费用' },
  { cmd: '/compact', desc: '压缩上下文' },
  { cmd: '/help', desc: '显示帮助' },
];

export const CUSTOM_MODEL_OPTION_VALUE = '__custom_model__';

export const MODE_LABELS: Record<string, string> = {
  default: '默认',
  plan: 'Plan',
  yolo: 'YOLO',
};

export const AGENT_LABELS: Record<string, string> = {
  claude: 'Claude',
  codex: 'Codex',
  opencode: 'OpenCode',
  genericagent: 'GenericAgent',
  hermes: 'Hermes',
};

export const DEFAULT_AGENT = 'claude';
export const SESSION_CACHE_LIMIT = 64;
export const PRELOAD_PREVIEW_MESSAGE_COUNT = 3;
export const SESSION_CACHE_MAX_ENTRY_WEIGHT = 5_000_000;
export const SESSION_CACHE_MAX_WEIGHT = 12_000_000;
export const SIDEBAR_SWIPE_TRIGGER = 72;
export const SIDEBAR_SWIPE_MAX_VERTICAL_DRIFT = 42;
export const SIDEBAR_WIDTH_STORAGE_KEY = 'webcoding-sidebar-width';
export const SIDEBAR_DEFAULT_WIDTH = 320;
export const SIDEBAR_MIN_WIDTH = 280;
export const SIDEBAR_MAX_WIDTH = 560;
export const GIT_PANEL_WIDTH_STORAGE_KEY = 'webcoding-git-panel-width';
export const GIT_PANEL_DEFAULT_WIDTH = 360;
export const GIT_PANEL_MIN_WIDTH = 280;
export const GIT_PANEL_MAX_WIDTH = 720;
export const DESKTOP_INSIGHTS_BREAKPOINT = 1280;
export const VISIBILITY_RESYNC_THROTTLE_MS = 2500;
export const SESSION_LIST_COLLATOR = new Intl.Collator('zh-CN', { numeric: true, sensitivity: 'base' });
export const INPUT_MAX_HEIGHT_FALLBACK = 200;
export const RECONNECT_MAX_ATTEMPTS = 8;
export const REMEMBERED_PASSWORD_STORAGE_KEY = 'webcoding-remembered-password';
export const THEME_STORAGE_KEY = 'webcoding-theme';
export const DEFAULT_THEME = 'default';
export const THEME_LABELS: Record<string, string> = {
  default: '默认主题',
  localhost: '极简主题',
};

export const MODE_PICKER_OPTIONS = [
  { value: 'yolo', label: 'YOLO', desc: '跳过所有权限检查' },
  { value: 'plan', label: 'Plan', desc: '执行前需确认计划' },
  { value: 'default', label: '默认', desc: '标准权限审批' },
];

export const WS_URL = `${location.protocol === 'https:' ? 'wss' : 'ws'}://${location.host}/ws`;
